// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://snowscan.xyz/address/0xEB0682d148e874553008730f0686ea89db7DA412
export const TRANSPARENT_PROXY_FACTORY = '0xEB0682d148e874553008730f0686ea89db7DA412';

// https://snowscan.xyz/address/0xD3cF979e676265e4f6379749DECe4708B9A22476
export const PROXY_ADMIN = '0xD3cF979e676265e4f6379749DECe4708B9A22476';

// https://snowscan.xyz/address/0x3b56998Ec06477704622ca8e2eA1b4db134cec32
export const CREATE_3_FACTORY = '0x3b56998Ec06477704622ca8e2eA1b4db134cec32';

// https://snowscan.xyz/address/0x06d958772304e7220fc3E463756CE01Ed0D24db2
export const AAVE_CL_ROBOT_OPERATOR = '0x06d958772304e7220fc3E463756CE01Ed0D24db2';

// https://snowscan.xyz/address/0x56C1a4b54921DEA9A344967a8693C7E661D72968
export const PROTOCOL_GUARDIAN = '0x56C1a4b54921DEA9A344967a8693C7E661D72968';

// https://snowscan.xyz/address/0xA065d5A299E618CD84a87641d5eEbC7916Fdf32E
export const AAVE_MERKLE_DISTRIBUTOR = '0xA065d5A299E618CD84a87641d5eEbC7916Fdf32E';

// https://snowscan.xyz/address/0x22740deBa78d5a0c24C58C740e3715ec29de1bFa
export const AFC_SAFE = '0x22740deBa78d5a0c24C58C740e3715ec29de1bFa';

// https://snowscan.xyz/address/0xA1c93D2687f7014Aaf588c764E3Ce80aF016229b
export const ALC_SAFE = '0xA1c93D2687f7014Aaf588c764E3Ce80aF016229b';

// https://snowscan.xyz/address/0xdef1FA4CEfe67365ba046a7C630D6B885298E210
export const MASIV_SAFE = '0xdef1FA4CEfe67365ba046a7C630D6B885298E210';

// https://snowscan.xyz/address/0xa9e777D56C0Ad861f6a03967E080e767ad8D39b6
export const APE_VOTING_SAFE = '0xa9e777D56C0Ad861f6a03967E080e767ad8D39b6';

// https://snowscan.xyz/address/0x4C6Cf8b226500d92FCBC498c3EC4C2e1091dAC08
export const REWARD_STEWARD = '0x4C6Cf8b226500d92FCBC498c3EC4C2e1091dAC08';

// https://snowscan.xyz/address/0x556bBE96f04b4610E48EE003DAcEE1C74de7AC6a
export const AGENT_HUB = '0x556bBE96f04b4610E48EE003DAcEE1C74de7AC6a';

// https://snowscan.xyz/address/0xe4E91893Dd64c48FC2F20410F37f203259ECA896
export const AGENT_HUB_AUTOMATION = '0xe4E91893Dd64c48FC2F20410F37f203259ECA896';

// https://snowscan.xyz/address/0x9240a6669CC4782FC98620212862DF5CB2e0Df10
export const RANGE_VALIDATION_MODULE = '0x9240a6669CC4782FC98620212862DF5CB2e0Df10';

export const CHAIN_ID = 43114;
